export const EVENT_CLICK = 'click'
export const EVENT_KEYDOWN = 'keydown'
export const KEY_ESCAPE = 'Escape'
export const KEY_ENTER = 'Enter'
export const KEY_ARROW_DOWN = 'ArrowDown'
export const KEY_ARROW_UP = 'ArrowUp'
